import "./AssignLabToTestViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../../constants";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import AssignLabToTestEditComponent from "./assign-lab-to-test-edit/AssignLabToTestEditComponent";
import AssignLabToTestViewComponent from "./assign-lab-to-test-view/AssignLabToTestViewComponent";

interface AssignLabToTestViewEditComponentProps {
    testDetails: any
    onUpdateInformation: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const AssignLabToTestViewEditComponent = (props: AssignLabToTestViewEditComponentProps) => {

    const {testDetails, onModeChange, canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [testAssignedLabsList, setTestAssignedLabsList] = useState<any>([]);
    const [isTestAssignedLabsListLoading, setIsTestAssignedLabsListLoading] = useState<boolean>(false);
    const [isTestAssignedLabsListLoaded, setIsTestAssignedLabsListLoaded] = useState<boolean>(false);
    const [isTestAssignedLabsListLoadingFailed, setIsTestAssignedLabsListLoadingFailed] = useState<boolean>(false);

    const handleTestAssignedLabs = useCallback((updatedAssignedLabs: any) => {
        setTestAssignedLabsList(updatedAssignedLabs);
        setMode("view");
    }, []);

    const handleTestAssignedLabsEditCancel = useCallback(() => {
        setMode("view");
    }, [])

    const getTestAssignedLabsList = useCallback(() => {
        setIsTestAssignedLabsListLoading(true);
        setIsTestAssignedLabsListLoaded(false);
        setIsTestAssignedLabsListLoadingFailed(false);
        CommonService._test.getsAssignedLabsToTest(testDetails?.id)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    setTestAssignedLabsList(response?.data?.map((lab:any)=> lab?.labDetailsResponse));
                }
                setIsTestAssignedLabsListLoading(false);
                setIsTestAssignedLabsListLoaded(true);
                setIsTestAssignedLabsListLoadingFailed(false);
            })
            .catch((error: any) => {
                setIsTestAssignedLabsListLoading(false);
                setIsTestAssignedLabsListLoaded(false);
                setIsTestAssignedLabsListLoadingFailed(true);
            });
    }, [testDetails])


    useEffect(() => {
        if (testDetails.id) {
            getTestAssignedLabsList();
        }
    }, [testDetails, getTestAssignedLabsList]);

    useEffect(() => {
        onModeChange(mode);
    }, [mode, onModeChange])

    return (
        <div className={'assign-lab-to-test-view-edit-component  details-tab-data-wrapper'}>
            {
                isTestAssignedLabsListLoading &&
                <div className="details-screen-loading-icon">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                isTestAssignedLabsListLoadingFailed &&
                <StatusCardComponent title={"Failed to load attachments"}
                />
            }
            {
                isTestAssignedLabsListLoaded && <>
                    {
                        mode === "view" && <AssignLabToTestViewComponent
                            assignedLabs={testAssignedLabsList}
                            canEdit={canEdit}
                            onEditModeOpen={() => {
                                setMode("edit")
                            }}
                        />
                    }
                    {
                        mode === "edit" && <AssignLabToTestEditComponent
                            testId={testDetails.id}
                            assignedLabs={testAssignedLabsList}
                            onUpdateComplete={handleTestAssignedLabs}
                            onEditCancel={handleTestAssignedLabsEditCancel}
                        />
                    }
                </>
            }

        </div>
    );

};

export default AssignLabToTestViewEditComponent;